module.exports = __webpack_public_path__ + "static/img/linyx-logo.bd955f9.png";